import api from "../../admin/infra/api";
import { useQuery } from "react-query";
import { VacancyType } from "../../users/types/user";
import formatDate from "../../core/utils/formatDate";
import { Pessoal } from "./@types/candidateTypes";

const endpoint = process.env.REACT_APP_API_URL + `api/candidate/avaliable`;
const updateEndpoint = process.env.REACT_APP_API_URL + `api/candidate`;
const selectionOptionsUrl =
  process.env.REACT_APP_API_URL + `api/candidate/selection/options`;
const getByIdUrl = process.env.REACT_APP_API_URL + `api/candidate`;
const getByIdUrlSys = process.env.REACT_APP_API_URL + `api/candidate/system`;
const updateCanInfo =
  process.env.REACT_APP_API_URL + `api/candidate/system/update`;
const deleteCanInfo = process.env.REACT_APP_API_URL + `api/candidate/user`;
const addCanInfo = process.env.REACT_APP_API_URL + `api/candidate/system/add`;
const findAllUrl = process.env.REACT_APP_API_URL + `api/candidate/search`;

async function fetchVacancy(): Promise<undefined | VacancyType[]> {
  try {
    const response = await api(endpoint);

    if (response.status >= 203) {
      return undefined;
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export function useVacancy() {
  return useQuery("vacancy", () => fetchVacancy());
}

export async function updateCandidate(colum: any, value: any, id: number) {
  try {
    const response = await api(updateEndpoint + `/${id}`, {
      method: "PUT",
      body: JSON.stringify({
        colum: colum,
        value: value,
      }),
      mode: "cors",
      headers: {
        "content-Type": "application/json",
      },
    });

    if (response.status >= 203) {
      return undefined;
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export const deleteCanInfoSys = async (
  id: number | undefined,
  type: string,
): Promise<boolean | undefined> => {
  let url = "";
  if (type == "UNIVERSITY") {
    url = deleteCanInfo + `/university/${id}`;
  }
  if (type == "WORKS") {
    url = deleteCanInfo + `/job/${id}`;
  }
  try {
    const response = await api(url, {
      method: "DELETE",
      mode: "cors",
      headers: {
        "content-Type": "application/json",
      },
    });

    if (response.ok) {
      return true;
    }
  } catch (error) {
    return false;
  }
};

export async function updateCandidateInfo(
  id: number | undefined,
  body: any,
  type: string,
) {
  try {
    const response = await api(updateCanInfo + `/${id}`, {
      method: "POST",
      body: JSON.stringify({
        type: type,
        body: body,
      }),
      mode: "cors",
      headers: {
        "content-Type": "application/json",
      },
    });

    if (response.status >= 203) {
      return undefined;
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export async function insertCandidate(
  body: any,
): Promise<{ id: number } | boolean> {
  try {
    const response = await api(updateEndpoint, {
      method: "POST",
      body: JSON.stringify({
        pessoal_cpf: body.pessoal_cpf?.replace(/[.-]/g, ""),
        pessoal_nome: body.pessoal_nome,
        pessoal_dtalteracao: body?.atualizada,
        pessoal_dtinclusao: body?.inclusao,
        pessoal_bairro: body?.bairro,
        pessoal_cidade: body?.cidade,
        pessoal_uf: body?.uf,
        pessoal_endereco: body?.endereco,
        pessoal_numero: body?.numero_end,
        pessoal_pwd: body?.pessoal_pwd,
        pessoal_email: body?.pessoal_email,
        pessoal_cep: body?.cep?.replace(/[.-]/g, ""),
        pessoal_telefones: body?.pessoal_telefones,
      }),
      mode: "cors",
      headers: {
        "content-Type": "application/json",
      },
    });

    if (response.status >= 203) {
      return false;
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.log(err);
    return false;
  }
}

export async function addCandidateInfo(
  id: number | undefined,
  body: any,
  type: string,
) {
  try {
    const response = await api(addCanInfo + `/${id}`, {
      method: "POST",
      body: JSON.stringify({
        type: type,
        body: body,
      }),
      mode: "cors",
      headers: {
        "content-Type": "application/json",
      },
    });

    if (response.status >= 203) {
      return undefined;
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export async function execSelectionOptions(id: number | undefined, body: any) {
  try {
    const response = await api(selectionOptionsUrl, {
      method: "POST",
      body: JSON.stringify({
        ...body,
        id: id,
      }),
      mode: "cors",
      headers: {
        "content-Type": "application/json",
      },
    });

    if (response.status >= 203) {
      return undefined;
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export async function getCandidate(id: number, name: string) {
  try {
    const response = await api(updateEndpoint + `/${id}?name=${name}`);

    const data = await response.text();

    if (name === "pessoal_idade") {
      const getDateBirthday = await api(
        updateEndpoint + `/${id}?name=pessoal_dtnasc`,
      );
      const date = await getDateBirthday.text();
      const birthDate = new Date(formatDate(date, "yyyy/MM/dd"));
      const currentDate = new Date();

      const difference = currentDate.getTime() - birthDate.getTime();
      const age = Math.floor(difference / (1000 * 60 * 60 * 24 * 365.25));
      return age;
    }

    if (data === "") {
      return "";
    }

    if (data === name) {
      return "";
    }

    return data;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export async function getCandidateInfo(id: number | undefined) {
  try {
    const response = await api(updateEndpoint + `/info/${id}`);
    if (response.status >= 203) {
      return undefined;
    }
    const data = await response.json();

    return data;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export async function sendCandidateTemplateEmail(
  candidateId: number,
  templateId: number = 7,
  overrides?: { to?: string; subject?: string; html?: string },
): Promise<{ ok: boolean; message?: string }> {
  try {
    const body: Record<string, unknown> = { candidateId, templateId };
    if (overrides) {
      body.to = overrides.to ?? "";
      body.subject = overrides.subject ?? "";
      body.html = overrides.html ?? "";
    }
    const response = await api(`${updateEndpoint}/send-template-email`, {
      method: "POST",
      body: JSON.stringify(body),
      mode: "cors",
      headers: {
        "content-Type": "application/json",
      },
    });
    if (response.status >= 300) {
      let message: string | undefined;
      try {
        const j = await response.json();
        message = j?.message;
      } catch {
        /* ignore */
      }
      return { ok: false, message };
    }
    return { ok: true };
  } catch (err) {
    console.log(err);
    return { ok: false, message: "Erro ao enviar e-mail." };
  }
}

export async function getCanHistory(id: number): Promise<any[] | boolean> {
  try {
    const response = await api(updateEndpoint + `/history/${id}`);

    if (response.status >= 203) {
      return false;
    }

    const data = await response.json();

    return data;
  } catch (err) {
    console.log(err);
    return false;
  }
}

export type FormacoesNType = {
  id: number;
  nf_descricao: string;
  formacao_n_STRING: string;
};

export const getFormacoesN = async (): Promise<FormacoesNType[] | boolean> => {
  const cepEndpoint =
    process.env.REACT_APP_API_URL + `api/utils/populate?label=formacoes_n`;
  try {
    const response = await api(cepEndpoint);

    if (response.status >= 203) {
      return false;
    }

    const data = await response.json();

    return data as FormacoesNType[];
  } catch (err) {
    console.log(err);
    return false;
  }
};

export async function getCandidateById(id: number): Promise<any> {
  try {
    const response = await api(getByIdUrl + `?id=${id}`);

    if (response.status >= 203) {
      return undefined;
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export async function getCandidateByIdSys(
  id: number,
): Promise<Pessoal | undefined> {
  try {
    const response = await api(getByIdUrlSys + `/${id}`);

    if (response.status >= 203) {
      return undefined;
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export async function findAllCandidates(filterValues?: any): Promise<any> {
  let response;
  try {
    if (filterValues) {
      const completeFilterValues = {
        search: filterValues.search || "",
        sex: filterValues.sex || "0",
        estcivil: filterValues.estcivil || "0",
        cagos: filterValues.cagos || [],
        instrucoes: filterValues.instrucoes || "0",
        cidades: filterValues.cidades || [],
        salario: filterValues.salario || "999999.99",
        cvatualizado_min: filterValues.cvatualizado_min || null,
        cvatualizado_max: filterValues.cvatualizado_max || null,
        entrevistados: filterValues.entrevistados || false,
        com_veiculos: filterValues.com_veiculos || false,
        contato_standby: filterValues.contato_standby || false,
        pri_emp: filterValues.pri_emp || false,
        pcd: filterValues.pcd || false,
        idade_min: filterValues.idade_min || "",
        idade_max: filterValues.idade_max || "",
        page: filterValues.page || 0,
        pageSize: filterValues.pageSize || 100,
        skipCount: filterValues.skipCount || false,
      };

      response = await api(findAllUrl, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(completeFilterValues),
      });
    } else {
      response = await api(findAllUrl);
    }

    if (response.status >= 203) {
      return undefined;
    }

    const data = await response.json();

    const result: any = {
      body: data.body || [],
      page: data.page || 0,
      pageSize: data.pageSize || 100,
    };

    if (data.total !== undefined && data.total !== null) {
      result.total = data.total;
    }

    return result;
  } catch (err) {
    console.log(err);
    return undefined;
  }
}

export async function searchCandidatesByName(
  searchTerm: string,
): Promise<any[]> {
  try {
    const searchUrl = process.env.REACT_APP_API_URL + `api/candidate/search`;

    const response = await api(searchUrl, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        search: searchTerm,
        sex: "0",
        estcivil: "0",
        cagos: [],
        instrucoes: "0",
        cidades: [],
        salario: "999999.99",

        cvatualizado_min: null,
        cvatualizado_max: null,
        entrevistados: false,
        com_veiculos: false,
        contato_standby: false,
        pri_emp: false,
        pcd: false,
        idade_min: "",
        idade_max: "",
      }),
    });

    if (response.status >= 203) {
      return [];
    }

    const data = await response.json();

    // Retornar apenas os campos necessários: ID, nome e data de cadastro
    if (data.body && Array.isArray(data.body)) {
      return data.body.map((candidate: any) => ({
        id: candidate.id || candidate.pessoal_codigo,
        pessoal_nome: candidate.pessoal_nome,
        autohis_dtincludo:
          candidate.autohis_dtincludo || candidate.pessoal_dtinclusao,
        pessoal_cidade: candidate.pessoal_cidade,
        pessoal_bairro: candidate.pessoal_bairro,
        pessoal_sexo: candidate.pessoal_sexo,
        pessoal_idade: candidate.pessoal_idade,
        pessoal_escolaridade: candidate.pessoal_escolaridade,
        profissional_cargo: candidate.profissional_cargo,
        profissional_pretensao_salarial:
          candidate.profissional_pretensao_salarial,
        pessoal_dtnascimento: candidate.pessoal_dtnascimento,
      }));
    }

    return [];
  } catch (err) {
    console.log("Erro na busca por nome:", err);
    return [];
  }
}

async function fetchRecentCandidates(limit: number = 5): Promise<any[]> {
  try {
    const recentEndpoint =
      process.env.REACT_APP_API_URL + `api/candidate/recent?limit=${limit}`;
    const response = await api(recentEndpoint);

    if (response.status >= 203) {
      return [];
    }

    const data = await response.json();

    if (Array.isArray(data)) {
      return data.map((candidate: any) => ({
        id: candidate.pessoal_codigo,
        pessoal_nome: candidate.pessoal_nome,
        pessoal_email: candidate.pessoal_email,
        pessoal_bairro: candidate.pessoal_bairro,
        pessoal_cidade: candidate.pessoal_cidade,
        pessoal_uf: candidate.pessoal_uf,
        pessoal_dtinclusao: candidate.pessoal_dtinclusao,
        pessoal_dtalteracao: candidate.pessoal_dtalteracao,
        img_usuario: candidate.img_usuario || null,
      }));
    }

    return [];
  } catch (err) {
    console.log("Erro ao buscar candidatos recentes:", err);
    return [];
  }
}

export function useRecentCandidates(limit: number = 5) {
  return useQuery(
    ["recentCandidates", limit],
    () => fetchRecentCandidates(limit),
    {
      staleTime: 5 * 60 * 1000, // 5 minutos
      cacheTime: 10 * 60 * 1000, // 10 minutos
    },
  );
}

export async function findCandidateByCPF(
  cpf: string,
): Promise<{ pessoal_codigo: number } | undefined> {
  try {
    const searchCPFUrl =
      process.env.REACT_APP_API_URL + `api/candidate/search/cpf`;

    const response = await api(searchCPFUrl, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        cpf: cpf,
      }),
    });

    if (response.status === 404) {
      return undefined;
    }

    if (response.status >= 203) {
      return undefined;
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.log("Erro na busca por CPF:", err);
    return undefined;
  }
}

export async function deleteCandidate(candidateId: number): Promise<boolean> {
  try {
    const deleteCandidateUrl =
      process.env.REACT_APP_API_URL + `api/candidate/system/${candidateId}`;

    const response = await api(deleteCandidateUrl, {
      method: "DELETE",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.ok) {
      return true;
    }

    return false;
  } catch (err) {
    console.log("Erro ao deletar candidato:", err);
    return false;
  }
}

// ============================================================================
// BATCH OPERATIONS - Operações otimizadas para buscar/atualizar múltiplos campos
// ============================================================================

const batchGetUrl = process.env.REACT_APP_API_URL + `api/candidate/batch`;
const batchFullUrl = process.env.REACT_APP_API_URL + `api/candidate/batch/full`;

/**
 * Busca todos os campos necessários para a página do candidato em uma única requisição
 * @param id - ID do candidato
 * @returns Objeto com todos os campos do candidato
 */
export async function getCandidateBatchFull(
  id: number,
): Promise<Record<string, any> | undefined> {
  try {
    const response = await api(`${batchFullUrl}/${id}`);

    if (response.status >= 203) {
      return undefined;
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.log("Erro ao buscar dados batch do candidato:", err);
    return undefined;
  }
}

/**
 * Busca campos específicos do candidato em uma única requisição
 * @param id - ID do candidato
 * @param fields - Array com nomes dos campos a buscar
 * @returns Objeto com os campos solicitados
 */
export async function getCandidateBatchFields(
  id: number,
  fields: string[],
): Promise<Record<string, any> | undefined> {
  try {
    const response = await api(`${batchGetUrl}/${id}`, {
      method: "POST",
      body: JSON.stringify({ fields }),
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.status >= 203) {
      return undefined;
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.log("Erro ao buscar campos batch do candidato:", err);
    return undefined;
  }
}

/**
 * Atualiza múltiplos campos do candidato em uma única requisição
 * @param id - ID do candidato
 * @param fields - Objeto com campo:valor a atualizar
 * @returns Resultado da atualização
 */
export async function updateCandidateBatch(
  id: number,
  fields: Record<string, any>,
): Promise<{ id: number; updated: number; fields: string[] } | undefined> {
  try {
    const response = await api(`${batchGetUrl}/${id}`, {
      method: "PUT",
      body: JSON.stringify({ fields }),
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (response.status >= 203) {
      return undefined;
    }

    const data = await response.json();
    return data;
  } catch (err) {
    console.log("Erro ao atualizar campos batch do candidato:", err);
    return undefined;
  }
}
